import React, { PureComponent } from 'react';
import TablaBodyMovimientosSinConfirmar from './TablaBodyMovimientosSinConfirmar';
import GlobalHelper from '../../../../Common/Helpers/GlobalHelper';

class TablaMovimientosSinConfirmar extends PureComponent {
    constructor(props) {
        super(props);
    }


    render() {
        const { MovimientosSinConfirmar, estaDesplegado, setEstaDesplegado } = this.props;

        let totalAutorizaciones = MovimientosSinConfirmar.totalAutorizaciones;
        let totalAjustesCargos = MovimientosSinConfirmar.totalAjustesCargos;
        let totalAjustesCargosNegativo = false;
        let totalAutorizacionesNegativo = false;

        if (totalAutorizaciones < 0) totalAutorizacionesNegativo = true;
        if (totalAjustesCargos < 0) totalAjustesCargosNegativo = true;

        totalAutorizaciones = JSON.parse(JSON.stringify(GlobalHelper.ConversionDeMilesAgregandoDecimales(totalAutorizaciones)));
        totalAjustesCargos = JSON.parse(JSON.stringify(GlobalHelper.ConversionDeMilesAgregandoDecimales(totalAjustesCargos)));

        if (totalAjustesCargosNegativo) {
            totalAjustesCargos = totalAjustesCargos.replace("-", "(")
            totalAjustesCargos += ")"
        }

        if (totalAutorizacionesNegativo) {
            totalAutorizaciones = totalAutorizaciones.replace("-", "(")
            totalAutorizaciones += ")"
        }


        return (
            <div className="movimientosSinConfirmarTable">
                <table className='width100 noBorder'>
                    <thead className='saldoHeaderBorde'>
                        <tr className={estaDesplegado ? 'height50 EditIcon paddingLeftXS paddingTopBottom header-movimientos-confirmados' : 'height50 EditIcon paddingLeftXS paddingTopBottom'}>
                            <th className="movimientosTableEstilo" colSpan="2">MOVIMIENTOS SIN CONFIRMAR</th>
                            <th className="movimientosTableEstilo" colSpan="1">
                                <div className="text-right">
                                    <a className={estaDesplegado ? "clickable none-text-decoration menu-desplegableMovimientos seccionRenglonesModelo__renglonModelo__trianguloUp seccionRenglonesModelo__renglonModelo__trianguloUp--activo" : "clickable none-text-decoration menu-desplegableMovimientos seccionRenglonesModelo__renglonModelo__trianguloDown"}
                                        onClick={() => setEstaDesplegado(!estaDesplegado)}>
                                    </a>
                                </div>
                            </th>
                        </tr>
                        {estaDesplegado ?
                            <tr className='height50 EditIcon paddingLeftXS paddingTopBottom'>
                                <th className='movimientosTableEstilo' style={{width:'110px'} }>FECHA</th>
                                <th className='movimientosTableEstilo' style={{width:'550px', alignContent:'left', paddingLeft: 0}}>CONCEPTO</th>
                                <th className='movimientosTableEstilo' style={{width:'120px', alignContent: 'left', paddingLeft: 0}}>$</th>
                            </tr>
                            : null}
                    </thead>
                </table>
                {estaDesplegado ?
                    <TablaBodyMovimientosSinConfirmar MovimientosSinConfirmar={MovimientosSinConfirmar} /> : null}
                {estaDesplegado ?
                    <table className='width100 noBorder'>
                        <tr className='height50 EditIcon paddingLeftXS paddingTopBottom movimientosSinConfirmarFooter'>
                            <td colSpan="3">
                                <span className="autorizacionesSinPresentar">AUTORIZACIONES SIN PRESENTAR: {totalAutorizaciones}</span>
                                <span className="ajustesCargosSinAplicar">AJUSTES / CARGOS SIN APLICAR: {totalAjustesCargos}</span>
                            </td>
                        </tr>
                    </table>
                    : null}
            </div>
        )
    }
}

export default TablaMovimientosSinConfirmar;